import { render, staticRenderFns } from "./SisIntegration.vue?vue&type=template&id=4c2920de&scoped=true&"
import script from "./SisIntegration.vue?vue&type=script&lang=js&"
export * from "./SisIntegration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../opt/jenkins_node_modules/doris/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c2920de",
  null
  
)

export default component.exports